<template>
	<div class="container">
		<div class="not-found">
			<h2 class="title">Page doesn't exist</h2>
			<div class="">
				Go back to main page
				<a class="home-page-link" href="/">Home</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NotFound",
};
</script>
<style scoped>
.not-found {
	padding-top: 25px;
	padding-bottom: 25px;
}
</style>